/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useSelector } from 'react-redux';
import AutoScrollWidgetRepositioning from '../AutoScrollWidgetRepositioning/AutoScrollWidgetRepositioning';
import BrowserMessages from '../BrowserMessages/BrowserMessages';
import Cookies from '../Cookies/Cookies';
import CrmAutoFill from '../CrmAutoFill/CrmAutoFill';
import HeadSection from '../HeadSection/HeadSection';
import InitialWidgetLoadEventManager from '../InitialWidgetLoadEventManager/InitialWidgetLoadEventManager';
import SubcategoryMatchesManager from '../SubcategoryMatchesManager/SubcategoryMatchesManager';
import Navigation from '../Navigation/Navigation';
import PageLayout from '../PageLayout/PageLayout';
import IdentitiesManager from '../VisitorIdManager/IdentitiesManager';
import Resubmissions from '../Resubmissions/Resubmissions';
import SubmissionStatus from '../SubmissionStatus/SubmissionStatus';
import NewsletterSignupManager from '../NewsletterSignupManager/NewsletterSignupManager';
import TrustedFormLoader from '../TrustedFormLoader/TrustedFormLoader';
import ApplicationError from '../ApplicationError/ApplicationError';
import SubmissionRetries from '../SubmissionRetries/SubmissionRetries';
import SupplierCardBrandManager from '../SupplierCardBrandManager/SupplierCardBrandManager';
import PartialLead from '../PartialLead/PartialLead';
import LottieLoader from '../LottieLoader/LottieLoader';
import AnuraManager from '../AnuraManager/AnuraManager';

const Form = () => {
  const { applicationError } = useSelector((store) => store.errors);
  if (applicationError) {
    return (
      <ApplicationError
        metricName={applicationError.metricName}
        logMessage={applicationError.logMessage}
        customerMessage={applicationError.customerMessage}
      />
    );
  }

  return (
    <>
      <HeadSection />
      <PageLayout />
      <BrowserMessages />
      <Resubmissions />
      <SubmissionStatus />
      <SubmissionRetries />
      <Cookies />
      <AnuraManager />
      <AutoScrollWidgetRepositioning />
      <InitialWidgetLoadEventManager />
      <SubcategoryMatchesManager />
      <SupplierCardBrandManager />
      <IdentitiesManager />
      <Navigation />
      <CrmAutoFill />
      <NewsletterSignupManager />
      <TrustedFormLoader />
      <LottieLoader />
      <PartialLead />
    </>
  );
};

export default Form;
